const getUrl = () => window.location || '';

const getParams = (param, url = getUrl().href) => {
  // eslint-disable-next-line no-useless-escape
  const paramName = param.replace(/[\[\]]/g, '\\$&').toLowerCase();
  var regex = new RegExp(`[?&]${paramName}(=([^&#]*)|&|#|$)`),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';

  return results[2].toUpperCase();
};

export { getParams, getUrl };
